import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _actions from '../../actions';
import constants from '../../constants';
import VersionBox from '../../components/common/VersionBox';
import EditInput from '../../components/forms/EditInput';
import GeneralSection from '../../components/common/GeneralSection';
import PreviewGroups from '../../components/preview/PreviewGroups';
import i18n from '../../i18n';
import HorizontalFormContainer from '../../components/forms/HorizontalFormContainer';
import OnOffSwitch from '../../components/forms/OnOffSwitch';
import DisplayOptionsBox from '../../components/forms/DisplayOptionsBox';
import ManagedInput from '../../components/forms/ManagedInput';
import PageBreak from '../../components/structure/PageBreak';
import UserSelectedIconSelect from '../../components/pages/UserSelectedIconSelect';

let defaultTabs = [];

export class GroupsModule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      menuItem: {},
      module: {},
      showPreview: true,
    };
    this.updateModuleFieldsWithValues = this.updateModuleFieldsWithValues.bind(this);
    this.updateMenuItemFromEvent = this.updateMenuItemFromEvent.bind(this);
    this.updateModuleFieldWithValue = this.updateModuleFieldWithValue.bind(this);
    this.updateModuleEnableGroups = this.updateModuleEnableGroups.bind(this);
    this.updateModuleEnableGroupFinder = this.updateModuleEnableGroupFinder.bind(this);
    this.updateModuleTabsFromEvent = this.updateModuleTabsFromEvent.bind(this);
  }

  componentDidMount() {
    this.props.actions.getProjectVersion(this.props.match.params.projectId);
    this.props.actions.getProjectVersionModules(this.props.match.params.projectId);
    this.props.actions.getProjectVersionMenuItems(this.props.match.params.projectId);
    this.props.actions.getModuleByType(this.props.match.params.projectId, 11);
    defaultTabs = [
      {
        name: 'groupsTabName',
        value: i18n.t('modules.groups.section2.tabDefault'),
      },
      {
        name: 'allGroupsTabName',
        value: i18n.t('modules.groups.section3.tabDefault'),
      },
    ];
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.modules.select.id
      && this.props.modules.select.moduleType === constants.ModuleType.find((m) => { return m.Name === 'Groups'; }).Id
      && this.props.modules.select.enabled) {
      if (this.props.alerts.data.length > 0 && this.props.alerts.data.find((m) => { return m.id === 'module-disabled'; })) {
        this.props.actions.clearAlert('module-disabled');
      }
    }
    if (!prevState.isLoaded) {
      if (this.props.modules.select.id
        && this.props.modules.select.moduleType === constants.ModuleType.find((m) => { return m.Name === 'Groups'; }).Id
        && !this.props.modules.select.enabled) {
        this.props.actions.addAlert({
          message: i18n.t('modules.groups.error1'),
          linkText: i18n.t('enableHere'),
          link: `/projects/${this.props.match.params.projectId}/modules/enable-modules`,
          view: '/modules/groups',
          type: 'warning',
          id: 'module-disabled',
        });
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ isLoaded: true });
      }
    }

    if ((!this.props.menuItems.inProgress
      && prevProps.menuItems.inProgress)
      || (!this.props.modules.inProgress
        && prevProps.modules.inProgress)) {
      let menuItem = this.props.menuItems.data.length > 0
        && typeof (this.props.modules.select.moduleType) === 'number'
        ? this.props.menuItems.data
          .find((mi) => {
            return mi.type === 1
              && parseInt(mi.subType, 10) === this.props.modules.select.moduleType;
          })
        : '';
      menuItem = menuItem || {};
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ menuItem });
    }
    if (!this.props.modules.inProgress && prevProps.modules.inProgress) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ module: this.props.modules.select });
    }
  }

  updateMenuItemFromEvent(evt) {
    const fieldName = evt.target.name;
    const changedValue = evt.target.value.trim().length > 0 ? evt.target.value.trim() : i18n.t('modules.groups.groups');
    if (changedValue !== '') {
      this.setState((prevState) => {
        return {
          menuItem: {
            ...prevState.menuItem,
            title: changedValue,
          },
        };
      });
      this.props.actions.updateMenuItemParameter(
        this.props.match.params.projectId,
        this.state.module.moduleType,
        1,
        fieldName,
        changedValue,
      );
    }
  }

  updateModuleEnableGroups(evt) {
    const changedValue = evt.target.checked;
    this.updateModuleFieldWithValue('groupsEnabled', changedValue);
    this.setState((prevState) => {
      return {
        module: {
          ...prevState.module,
          groupsEnabled: changedValue,
        },
      };
    });
  }

  updateModuleEnableGroupFinder(evt) {
    const changedValue = evt.target.checked;
    this.updateModuleFieldWithValue('groupfinderEnabled', changedValue);
    this.setState((prevState) => {
      return {
        module: {
          ...prevState.module,
          groupFinderEnabled: changedValue,
        },
      };
    });
  }

  updateModuleFieldsWithValues(fields) {
    this.props.actions.updateModule(
      this.props.match.params.projectId,
      this.state.module.moduleType,
      fields,
    );
  }

  updateModuleFieldWithValue(field, val) {
    this.props.actions.updateModuleParameter(
      this.props.match.params.projectId,
      this.state.module.moduleType,
      field,
      val,
    );
  }

  updateModuleTabsFromEvent(evt) {
    const fieldName = evt.target.name;
    const changedValue = evt.target.value.trim();
    if (changedValue !== '') {
      const newState = this.state.module;
      newState[fieldName] = changedValue;
      this.setState({ module: { ...newState } });
      this.updateModuleFieldWithValue(fieldName, changedValue);
    } else {
      const fieldData = defaultTabs.find((tab) => { return tab.name === fieldName; });
      const newState = this.state.module;
      newState[fieldName] = fieldData.value;
      this.setState({ module: { ...newState } });
      this.updateModuleFieldWithValue(fieldName, fieldData.value);
    }
  }

  render() {
    let previewGroups = null;
    let bodyForm = '';
    if (this.state.module.enabled) {
      let activeCheckin = this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'Check-In'; }).Id; });
      activeCheckin = activeCheckin.filter((module) => { return module.enabled === true; });
      previewGroups = (
        <PreviewGroups
          module={this.state.module}
          menuItem={this.state.menuItem}
          baseColorTheme={this.props.versions.select.baseColorTheme}
          actionColor={this.props.versions.select.actionColor}
          accentColor={this.props.versions.select.accentColor}
          secondaryText={this.props.versions.select.secondaryText}
          primaryText={this.props.versions.select.primaryText}
          menuStyle={this.props.versions.select.menuStyle}
          menuItems={this.props.menuItems.data}
          flags={this.props.flags}
          checkin={
            this.props.flags.results?.chMSIntegration
            && this.props.flags.results?.chMSCheckIn
            && activeCheckin.length > 0
          }
        />
      );
      bodyForm = (
        <div className="form-wrapper">
          <h1
            data-qa="groups-page-header"
            id="groups-page-header"
          >
            {i18n.t('modules.groups.title')}
          </h1>

          {this.props.flags.results?.scGroups
            && (
              <p
                data-qa="groups-page-subhead"
                id="groups-page-subhead"
                className="lead"
              >
                {i18n.t('modules.groups.subtitle')}
              </p>
            )}

          <GeneralSection
            name={i18n.t('modules.groups.section1')}
            sectionClass="edit-module-name module-display-settings-list"
          >
            <div
              id="module-display-setting"
              className="module-display-setting"
            >
              <EditInput
                containerId="edit-module-name"
                containerClass="edit-module-name-wrap"
                name="title"
                labelText={i18n.t('name')}
                value={this.state.menuItem !== {} && this.state.menuItem.title ? this.state.menuItem.title : ''}
                charLimit={12}
                onBlur={this.updateMenuItemFromEvent}
                onReturnDown={this.updateMenuItemFromEvent}
                actionClass="edit-module-name-action"
                placeholder={i18n.t('modules.groups.groups')}
                dataqa="groups-module-name"
                menuTitle
              />
              {this.props.flags.results?.userSelectedIcons
                && (
                  <HorizontalFormContainer
                    inputClass="module-display-setting__setting"
                    title="Menu Icon"
                  >
                    <UserSelectedIconSelect
                      id={this.state.menuItem.subType}
                      type={this.state.menuItem.type}
                      autoUpdate
                    />
                  </HorizontalFormContainer>
                )}
            </div>
          </GeneralSection>

          <GeneralSection
            sectionClass="module-display-settings-list"
            dataqa="module-display-settings"
          >
            <div
              data-qa="groups-settings"
              id="groups-settings"
              className={'module-display-setting module-setting-on'}
            >
              {this.props.flags.results?.scGroups
                && (
                  <DisplayOptionsBox
                    title={i18n.t('modules.groups.section2.groupfinderToggle')}
                  >
                    <OnOffSwitch
                      id="groupfinder-enabled"
                      buttonClass="toggle checkbox md-checkbox"
                      isToggleOn={this.state.module.groupFinderEnabled}
                      name="groupFinderEnabled"
                      onChange={this.updateModuleEnableGroupFinder}
                      dataQA="groupfinder-enabled"
                    />
                    <p>
                      {i18n.t('modules.groups.section2.groupfinderHelp1')}
                      <a
                        rel="noopener noreferrer"
                        target="_blank"
                        href={`https://${this.props.profiles.data.sccrmUrl}/settings/group_finder`}
                      >
                        {i18n.t('modules.groups.section2.groupfinderSettings')}
                      </a>
                      {i18n.t('modules.groups.section2.groupfinderHelp2')}
                    </p>

                  </DisplayOptionsBox>
                )}
            </div>
          </GeneralSection>
        </div>
      );
    }
    return (
      <VersionBox
        name={this.props.versions.select.name}
        versionNumber={this.props.versions.select.version}
        saving={this.props.modules.inProgress}
        justSaved={this.props.modules.justSaved}
        menuSection="Modules"
        menuItem="GroupsModule"
        previewCssClass="modules_groups"
        previewChild={previewGroups}
        showPreview={this.state.showPreview}
        x
      >
        <div id="groups-module" className="content-inside">
          {bodyForm}
        </div>
      </VersionBox>

    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    ...state,
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(_actions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupsModule);
